import { useEffect, useState, useRef } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { selectDescription } from "../components/store/slices/ssrDescriptionSlice";
import { SWITCH_SLICES } from "../components/store/slices/switchSlices";
import { systemOf } from "../constants/systems";
import { useSwitchState } from "./useSwitchState";
import { getSSRsForDeviceService } from "../services";
import { buildSpecsFromHeaters } from "../helpers/buildSpecsFromHeaters";

export const useGetSSRsQueries = (location, machine, swtName) => {
  const dispatch = useDispatch();
  const { elementsOptions } = useSelector(selectDescription);
  const { flat: swtStatus } = useSwitchState(swtName);
  const { setSSRState } = SWITCH_SLICES[systemOf(swtName).key];

  const [fetchSSRs, setFetchSSRs] = useState(false);
  const initialFetch = useRef(false);

  useEffect(() => {
    if (elementsOptions.length > 0 && !initialFetch.current) {
      setFetchSSRs(true);
      initialFetch.current = true;
    }
  }, [elementsOptions]);

  const getSSRsQueries = useQuery(
    [machine, '-ssrsData'],
    () => getSSRsForDeviceService(machine),
    {
      enabled: fetchSSRs,
      onSuccess: (data) => {
      
        if (data) {
   
          const result = data.map((item) => {
           
          
            const specs = buildSpecsFromHeaters(item.Heaters, elementsOptions);
     
            return {
              ...item,
              select: `tc-${swtStatus[location][machine].heaterThermocoupleMap[item.No]}`,
              buttonStatus: item?.fault === true || item?.Load_exceeded === true ? 'flt' :
                item?.active === true ? 'on' : 'off',
              specs: specs.length !== 0 ? specs?.map((spec) => ({
                currentSSR:swtStatus[location][machine].ssr_current?.[item.No],
                ...spec,
              })) : [{}],
              switchName: `${item.name} ${item.size}`,
            };
          });
          const ssrStateData = {
            location,
            machine,
            data: result,
          };
          dispatch(setSSRState(ssrStateData));
        }
      },
      onError: (error) => {
        console.error('get ssrs fail:', error.message);
      },
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: false,
    }
  );
  const { remove } = getSSRsQueries;

  useEffect(() => {
    return () => {
      remove();
    };
  }, [remove]);

  return getSSRsQueries;
};
